<template>
    <div class="pie-page">
        <div class="pie-scroll">
            <div class="pie-body">
                <input
                    v-model.trim="email"
                    class="pie-input"
                    type="email"
                    inputmode="email"
                    autocomplete="email"
                    placeholder="请输入您的邮箱信息"
                >
                <p class="pie-hint">
                    点击发送后，您的个人信息将在邮件附件内发送至您填写的邮箱，请注意查看。
                </p>
            </div>
        </div>

        <div class="pie-footer">
            <button
                type="button"
                class="pie-btn-main"
                :disabled="sending || cooldownSec > 0"
                @click="handleSend"
            >
                {{sendButtonLabel}}
            </button>
        </div>
    </div>
</template>

<script>
import {Toast} from 'vant';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const COOLDOWN_MS = 60000;
const STORAGE_KEY_PREFIX = 'mp_pi_export_cd_';

/** 与后端约定：发送过于频繁 */
const EXPORT_ERR_TOO_FREQUENT = 1002;

function isApiSuccess(res) {
    return res && (res.code === 0 || res.code === '0');
}

export default {
    name: 'PersonalInfoExport',
    components: {
    },
    data() {
        return {
            email: '',
            sending: false,
            cooldownSec: 0,
            tickTimer: null,
        };
    },
    computed: {
        sendButtonLabel() {
            if (this.cooldownSec > 0) {
                return `${this.cooldownSec}s`;
            }
            return '发送';
        },
    },
    mounted() {
        document.title = '个人信息导出';
        this.refreshCooldownFromStorage();
        this.tickTimer = setInterval(() => this.tickCooldown(), 1000);
    },
    beforeUnmount() {
        if (this.tickTimer) {
            clearInterval(this.tickTimer);
        }
    },
    methods: {
        cooldownStorageKey() {
            const {uid} = this.$route.query;
            return uid ? `${STORAGE_KEY_PREFIX}${uid}` : '';
        },
        refreshCooldownFromStorage() {
            const key = this.cooldownStorageKey();
            if (!key) {
                this.cooldownSec = 0;
                return;
            }
            // 隐私模式 / webview 禁用存储时 sessionStorage 会抛异常，
            // 冷却只是体验优化，不能因此阻断导出主流程
            let until = 0;
            try {
                until = Number.parseInt(sessionStorage.getItem(key) || '0', 10);
            }
            catch (e) {
                until = 0;
            }
            const left = Math.ceil((until - Date.now()) / 1000);
            this.cooldownSec = left > 0 ? left : 0;
        },
        tickCooldown() {
            if (this.cooldownSec > 0) {
                this.cooldownSec -= 1;
            }
            else {
                this.refreshCooldownFromStorage();
            }
        },
        armCooldown() {
            const key = this.cooldownStorageKey();
            if (!key) {
                return;
            }
            try {
                sessionStorage.setItem(key, String(Date.now() + COOLDOWN_MS));
            }
            catch (e) {
                // 存储不可用时仅本次会话内计时，不影响冷却生效
            }
            this.cooldownSec = Math.ceil(COOLDOWN_MS / 1000);
        },
        handleSend() {
            if (this.sending || this.cooldownSec > 0) {
                return;
            }
            if (!EMAIL_RE.test(this.email)) {
                Toast.fail('请输入正确的邮箱地址');
                return;
            }
            const {uid} = this.$route.query;
            if (!uid) {
                Toast.fail('缺少用户参数');
                return;
            }
            this.sending = true;
            this.$http.qsPost(this.$Api.personalInfoExport, {
                uid,
                email: this.email,
            })
                .then(res => {
                    if (isApiSuccess(res)) {
                        this.armCooldown();
                        const tip = (res.msg === 'success' || res.msg === 'SUCESS')
                            ? '已受理发送，请留意邮箱'
                            : (res.msg || '已受理发送，请留意邮箱');
                        Toast.success(tip);
                    }
                    else {
                        const code = res?.code;
                        if (code === EXPORT_ERR_TOO_FREQUENT || code === String(EXPORT_ERR_TOO_FREQUENT)) {
                            this.armCooldown();
                        }
                        Toast.fail(res?.msg || '发送失败，请稍后重试');
                    }
                })
                .catch(function handleExportSendError() {
                    // 网络异常已由 http 拦截器提示
                })
                .then(() => {
                    this.sending = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
$accent: #ff5242;
$text: #222;
$muted: #999;
$line: #eee;
$input-bg: #f5f5f5;

.pie-page {
    box-sizing: border-box;
    min-height: 100vh;

    max-width: 520px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: #fff;
    color: $text;
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", sans-serif;
}

.pie-nav {
    flex-shrink: 0;
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    padding: 0 16px;
    border-bottom: 1px solid $line;
    background: #fff;
}

.pie-nav__back {
    position: absolute;
    left: 0;
    top: 0;
    width: 44px;
    height: 44px;
    border: 0;
    padding: 0;
    background: transparent;
    cursor: pointer;
}

.pie-nav__back::before {
    content: "";
    position: absolute;
    left: 14px;
    top: 50%;
    width: 10px;
    height: 10px;
    margin-top: -5px;
    border-left: 2px solid #111;
    border-bottom: 2px solid #111;
    transform: rotate(45deg);
}

.pie-nav__title {
    margin: 0;
    font-size: 17px;
    font-weight: 600;
    text-align: center;
    line-height: 44px;
}

.pie-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.pie-body {
    padding: 20px 20px 24px;
    box-sizing: border-box;
}

.pie-input {
    display: block;
    width: 100%;
    box-sizing: border-box;
    border: 0;
    border-radius: 8px;
    padding: 14px 16px;
    font-size: 15px;
    background: $input-bg;
    color: $text;
    outline: none;
}

.pie-input::placeholder {
    color: #bbb;
}

.pie-hint {
    margin: 16px 0 0;
    font-size: 13px;
    line-height: 1.6;
    color: $muted;
}

.pie-footer {
    flex-shrink: 0;
    padding: 12px 20px calc(12px + env(safe-area-inset-bottom, 0px));
    background: #fff;
    border-top: 1px solid $line;
}

.pie-btn-main {
    display: block;
    width: 100%;
    box-sizing: border-box;
    border: 0;
    border-radius: 25px;
    padding: 14px 16px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background: $accent;
    cursor: pointer;
}

.pie-btn-main:disabled {
    opacity: .55;
}

@media (orientation: landscape) and (max-height: 420px) {
    .pie-body {
        padding-top: 12px;
    }

    .pie-hint {
        margin-top: 12px;
        font-size: 12px;
    }

    .pie-footer {
        padding-top: 8px;
        padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));
    }

    .pie-btn-main {
        padding: 10px 16px;
    }
}
</style>
